import React, { useState } from 'react';
import 'moment/locale/it';
import { UIModal, UIModalBody, UIModalButtons, UIModalHeader, UiModalInternal } from '../../utilities/Modal';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { UIInput } from '../../utilities/Input';
import { UIFormControlBox } from '../../utilities/Form';
import { UIButton } from '../../utilities/Button';
import { IconCheck } from '@tabler/icons-react';
import { useAccounts } from '../../../hooks/Accounts/useAccounts';
import { toast } from 'react-toastify';
import { UIPageHeader } from '../../utilities/Headers';
import { UiDialog } from '../../utilities/Dialog';

const ModalAddPatient = ({ modalOpen, handleModalClose }) => {
  const { onAddPatientDoctor } = useAccounts();
  const [confirmMode, setConfirmMode] = useState(false);
  const [valuesToConfirm, setValuesToConfirm] = useState(null);


  const handleSubmit = (values) => {
    values.name = values.name.trim();
    values.surname = values.surname.trim();
    values.email = values.email ? values.email.trim() : null;
    onAddPatientDoctor(values).then((res) => {
      if (!res?.responseStatus && res?.response === 'PATIENT_NOT_EXIST') {
        setConfirmMode(true);
        setValuesToConfirm(values);
      } else {
        toast(res?.response, {
          style: {
            fontSize: '14px',
            backgroundColor: res?.responseStatus ? '#00e676' : '#FF646C',
            color: '#ffffff'
          }
        });
        if (res?.responseStatus) {
          handleModalCloseInternal();
        }
      }
    });
  };

  const onConfirmCreatePatient = () => {
    if (valuesToConfirm) {
      onAddPatientDoctor({ ...valuesToConfirm, create_account: true }).then((res) => {
        toast(res?.response, {
          style: {
            fontSize: '14px',
            backgroundColor: res?.responseStatus ? '#00e676' : '#FF646C',
            color: '#ffffff'
          }
        });
        if (res?.responseStatus) {
          handleModalCloseInternal();
        }
      })
    }
  }

  const handleModalCloseInternal = () => {
    setConfirmMode(false);
    setValuesToConfirm(null);
    handleModalClose();
  };

  return (
    <UIModal open={modalOpen} onClose={handleModalCloseInternal} allowFullScreen={true} className={'modal'}>
      <UiModalInternal
        onClose={handleModalCloseInternal}
        containerSx={{
          bgcolor: '#FFF'
        }}
      >
        <Formik
          enableReinitialize={false}
          initialValues={{
            name: '',
            surname: '',
            email: ''
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string().required('Obbligatorio'),
            surname: Yup.string().required('Obbligatorio'),
            email: Yup.string()
              .email('Inserisci un indirizzo email valido').required('Inserisci un email valido')
          })}
          onSubmit={(values) => handleSubmit(values)}
        >
          {({ errors, handleSubmit, touched, values, submitForm, setFieldValue }) => (
            <form onSubmit={handleSubmit} id={'appointment-form'}>
              <UIModalHeader>
                <UIPageHeader
                  title={'Aggiungi nuovo paziente'}
                  sx={{
                    textAlign: 'center',
                    marginTop: '0px'
                  }}
                />
              </UIModalHeader>
              <UIModalBody>
                <UIFormControlBox>
                  <UIPageHeader
                    title={'Dati richiesti'}
                    subtitle={'Tutti i campi sono obbligatori.'}
                    sx={{
                      textAlign: 'center',
                      marginTop: '0px',
                      padding: '0px'
                    }}
                    sxSubtitle={{
                      textAlign: 'center',
                      marginX: '2px'
                    }}
                  />
                </UIFormControlBox>

                <UIFormControlBox label={'Nome'} error={Boolean(touched.name && errors.name)} error_message={errors?.name}>
                  <UIInput value={values.name} onChange={(e) => setFieldValue('name', e.target.value)} />
                </UIFormControlBox>

                <UIFormControlBox label={'Cognome'} error={Boolean(touched.surname && errors.surname)} error_message={errors?.surname}>
                  <UIInput value={values.surname} onChange={(e) => setFieldValue('surname', e.target.value)} />
                </UIFormControlBox>

                <UIFormControlBox label={'Email'} error={Boolean(touched.email && errors.email)} error_message={errors?.email}>
                  <UIInput value={values.email} onChange={(e) => setFieldValue('email', e.target.value)} />
                </UIFormControlBox>
              </UIModalBody>
              <UIModalButtons>
                <UIButton type={'submit'} onClick={() => submitForm()} icon={<IconCheck stroke={'1.64'} size={'26px'} />} />
              </UIModalButtons>
            </form>
          )}
        </Formik>
      </UiModalInternal>
      <UiDialog
        type={'default'}
        variant={'confirm'}
        title={'Il paziente non esiste. Confermi di volerlo creare?'}
        open={confirmMode}
        onClose={() => {
          setConfirmMode(false);
          setValuesToConfirm(null);
        }}
        onConfirm={onConfirmCreatePatient}
      />
    </UIModal>
  );
};

export default ModalAddPatient;
